
export function toCommas(value) {
    if(value)
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
else{
    return;
}
}

/**
 * Parse business invoice numbers like `2026-27/17438` into year label + numeric sequence.
 * Sequence is the part after the last `/` (not a string compare).
 */
export function getInvoiceNumberParts(invoiceNumber) {
  const s = String(invoiceNumber ?? "").trim();
  if (!s) return { yearLabel: "", sequence: 0 };

  const slash = s.lastIndexOf("/");
  if (slash < 0) {
    const n = parseInt(s, 10);
    return { yearLabel: "", sequence: Number.isFinite(n) ? n : 0 };
  }

  const yearLabel = s.slice(0, slash);
  const n = parseInt(s.slice(slash + 1), 10);
  return {
    yearLabel,
    sequence: Number.isFinite(n) ? n : 0,
  };
}

/** Descending compare: higher FY label first, then higher numeric sequence. */
export function compareInvoiceNumbersDesc(a, b) {
  const left = a && typeof a === "object" ? a.invoiceNumber : a;
  const right = b && typeof b === "object" ? b.invoiceNumber : b;
  const pa = getInvoiceNumberParts(left);
  const pb = getInvoiceNumberParts(right);

  if (pa.yearLabel !== pb.yearLabel) {
    return pb.yearLabel.localeCompare(pa.yearLabel);
  }
  return pb.sequence - pa.sequence;
}

/** Newest business invoice number first (numeric sequence after `/`). */
export function sortInvoicesByNumberDesc(invoices) {
  if (!Array.isArray(invoices)) return [];
  return [...invoices].sort(compareInvoiceNumbersDesc);
}

/**
 * Resolve a usable entity id for routing / API calls.
 * Accepts MySQL Int ids (number or numeric string).
 * Still reads legacy `_id` if present on older payloads.
 */
export function resolveEntityId(value) {
  if (value == null || value === "") return null;
  if (typeof value === "number") {
    return Number.isInteger(value) && value > 0 ? String(value) : null;
  }
  if (typeof value === "string") {
    const s = value.trim();
    if (!s || s === "[object Object]") return null;
    // Reject legacy Mongo ObjectId hex — not valid MySQL PKs
    if (/^[a-fA-F0-9]{24}$/.test(s)) return null;
    return s;
  }
  if (typeof value === "object") {
    if (typeof value.toJSON === "function") {
      const json = value.toJSON();
      if (typeof json === "string" || typeof json === "number") {
        return resolveEntityId(json);
      }
    }
    if (value.id != null && typeof value.id !== "object") {
      return resolveEntityId(value.id);
    }
    if (value._id != null && typeof value._id !== "object") {
      return resolveEntityId(value._id);
    }
    if (typeof value.toString === "function") {
      const s = value.toString();
      if (s && s !== "[object Object]") return resolveEntityId(s);
    }
  }
  return null;
}
